/**
 * Check if URL is internal or not
 * @param url
 * @returns {boolean}
 */
export function isInternalURL(url)
{
  const hostName = window.location.hostname

  return -1 !== url.indexOf(hostName)
}

/**
 * Check if URL is an admin URL or not
 * @param url
 * @returns {boolean}
 */
export function isAdminURL(url)
{
  return -1 !== url.indexOf('/wp-admin/')
}